import { createBrowserRouter } from "react-router-dom";
import { OppgaveOversikt } from "../components/oppgave-oversikt/OppgaveOversikt";
import PageRoot from "@helsenorge/core-framework/pageroot";
import { useGetResources } from "../hooks/useGetResources";
import { OppgaveDetaljer } from "../components/oppgave-detaljer/OppgaveDetaljer";
import type { BreadcrumbLink } from "@helsenorge/core-framework/breadcrumb";

const OppgaveOversiktRoute = () => {
  const resources = useGetResources();
  return (
    <PageRoot
      enablePageviewTracking
      enableSurveys
      hasPageHeader
      pageTitle={resources?.heading_oppgaver}
      pageDescription={resources?.heading_beskrivelse}
    >
      <OppgaveOversikt />
    </PageRoot>
  );
};

const OppgaveDetaljerRoute = () => {
  const resources = useGetResources();
  const oppgaverBreadcrumb: BreadcrumbLink = {
    name: resources?.breadcrumb_oppgaver || "",
    url: "/oppgaver",
    renderAsRouterLink: true,
  };

  return (
    <PageRoot
      enablePageviewTracking
      enableSurveys
      hasPageHeader={false}
      breadcrumbLink={oppgaverBreadcrumb}
    >
      <OppgaveDetaljer />
    </PageRoot>
  );
};

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <OppgaveOversiktRoute />,
  },
  {
    path: "/oppgaver",
    element: <OppgaveOversiktRoute />,
  },
  {
    path: "/oppgaver/:oppgaveGuid",
    element: <OppgaveDetaljerRoute />,
  },
]);
